'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "selected", "tooltip"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIButton from '../../button/UIButton';
import UIIcon from '../../icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import { DROPDOWN_FONT_SIZE } from 'HubStyleTokens/sizes';
import UITooltip from '../../tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ButtonChildWrapper = styled.span.withConfig({
  displayName: "DropdownMenuOption__ButtonChildWrapper",
  componentId: "sc-1wex4mc-0"
})(["display:flex;justify-content:space-between;align-items:center;"]);
export default function DropdownMenuOption(_ref) {
  let {
      children,
      selected,
      tooltip
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const selectedProps = selected !== null ? {
    role: 'menuitemcheckbox',
    'aria-checked': selected
  } : {
    role: 'menuitem'
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip,
    placement: "right",
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({
      use: "transparent"
    }, rest, selectedProps, {
      children: /*#__PURE__*/_jsxs(ButtonChildWrapper, {
        children: [/*#__PURE__*/_jsx("span", {
          className: "private-dropdown__button-label uiDropdown__buttonLabel",
          children: children
        }), selected ? /*#__PURE__*/_jsx(UIIcon, {
          name: "success",
          size: parseInt(DROPDOWN_FONT_SIZE, 10),
          color: EERIE
        }) : null]
      })
    }))
  });
}
DropdownMenuOption.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
  tooltip: PropTypes.node
};
DropdownMenuOption.defaultProps = {
  selected: null
};
DropdownMenuOption.displayName = 'DropdownMenuOption';